import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FavoritesService {
  private favoritesSubject = new BehaviorSubject<string[]>([]);
  public favorites$ = this.favoritesSubject.asObservable();
  
  constructor(private afs: AngularFirestore) {}

  async loadFavorites(userId: string) {
    const snapshot = await this.afs.collection('users').doc(userId).get().toPromise();
    if (snapshot && snapshot.exists) {
      const data: any = snapshot.data();
      const favs = data.favorites || [];
      this.favoritesSubject.next(favs);
    }
  }

  async toggleFavorite(userId: string, projectId: string | number) {
    const projIdStr = String(projectId);
    const current = this.favoritesSubject.value;
    const isFavorite = current.includes(projIdStr);
    
    const newFavorites = isFavorite ? current.filter(id => id !== projIdStr) : [...current, projIdStr];
    
    // Optimistic UI update
    this.favoritesSubject.next(newFavorites);
    
    try {
      await this.afs.collection('users').doc(userId).update({ favorites: newFavorites });
    } catch (e) {
      console.error('Error toggling favorite', e);
      // Rollback on error
      this.favoritesSubject.next(current);
    }
  }

  isFavorite(projectId: string | number): boolean {
    return this.favoritesSubject.value.includes(String(projectId));
  }
}
